export class GoogleTagManager {
  static sendClickEvent(eventCategory: string, eventLabel: string) {
    if(eventCategory && eventLabel) {
      (<any>window).dataLayer.push({
        'event': 'customEvent',
        'eventCategory': eventCategory,
        'eventAction': 'Click',
        'eventLabel': eventLabel
      });
    }
  }

  static sendCustomEvent(event: string, eventCategory: string, eventAction: string, eventLabel: string) {
    if(event && eventCategory && eventAction && eventLabel) {
      (<any>window).dataLayer.push({
        'event': event,
        'eventCategory': eventCategory,
        'eventAction': eventAction,
        'eventLabel': eventLabel
      });
    }
  }

  static sendPageViewEvent(pageURL: string, pageName: string) {
    if(pageURL && pageName) {
      (<any>window).dataLayer.push({
        'event': 'VirtualPageview',
        'virtualPageURL': pageURL,
        'virtualPageTitle': pageName
      });
    }
  }
}
  